import PropTypes from "prop-types";
import { useState } from "react";

import Button from "components/shared/button/Button";
import Hero from "components/shared/hero/Hero";
import Title from "components/shared/hero/title/Title";
import Container from "components/shared/container/Container";
import Accordion from "components/shared/accordion/Accordion";

import { PrivacyStyled, Content, Image, HeroText } from "./Privacy.styled";

export default function Privacy({ items, fileUrl }) {
    const [activeItem, setActiveItem] = useState(null);
    const breadcrumbsItems = [
        {
            title: "Cookie & Privacy",
            url: "/cookie-privacy"
        }
    ];

    return (
        <PrivacyStyled>
            <Hero breadcrumbs={breadcrumbsItems} contentWidth="half">
                <Title>Cookie & Privacy Policy</Title>
                <HeroText>
                    Beste bezoeker van Lees! Cadeaukaart. Welkom op onze
                    privacypagina. Wij begrijpen heel goed dat onze klanten zich
                    voor hun aankoop willen informeren over hoe wij met
                    persoonsgegevens omgaan. Het kan ook zijn dat je op een
                    andere manier met ons in contact bent gekomen via
                    bijvoorbeeld onze klantenservice en nieuwsgierig bent naar
                    onze omgang met jouw persoonlijke informatie.
                </HeroText>
            </Hero>
            <Container>
                <Content>
                    {items.map(item => (
                        <Accordion
                            key={item.id}
                            title={item.title}
                            variant="box"
                            active={activeItem === item.id}
                            onExpand={() => setActiveItem(item.id)}
                            onCollapse={() => setActiveItem(null)}
                        >
                            {item.content.replace(/\n/gi, "\n\n")}
                        </Accordion>
                    ))}
                    {fileUrl && (
                        <Button
                            element="a"
                            href={fileUrl}
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            Download als PDF
                        </Button>
                    )}
                </Content>
                <Image />
            </Container>
        </PrivacyStyled>
    );
}

Privacy.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            title: PropTypes.string,
            content: PropTypes.string
        })
    ),
    fileUrl: PropTypes.string
};

Privacy.defaultProps = {
    fileUrl: undefined,
    items: [
        {
            id: 1,
            title: "Om je bestelling te verwerken",
            content:
                "Als u bij ons een cadeaubon aanschaft hebben wij een " +
                "aantal persoonsgegevens nodig om u van dienst te kunnen zijn " +
                "en om uw bestelling te verwerken. Dit zijn jouw naam, " +
                "(e-mail)adres en telefoonnummer. Wij maken hierbij gebruik " +
                "van een webbouwer, hostingprovider en PostNL. Deze partners " +
                "hebben toegang tot de persoonsgegevens die u bij het " +
                "plaatsen van uw bestelling met ons deelt. Vandaar dat wij " +
                "hoge eisen stellen aan hun beveiliging. Wij maken met al " +
                "deze organisaties afspraken over de beveiliging en " +
                "bewaartermijnen. Omdat wij werken met cadeaukaarten die " +
                "met een bepaald saldo worden opgewaardeerd vinden wij " +
                "het voor beide partijen prettig als wij u snel kunnen " +
                "bereiken in geval van vragen. Vandaar dat wij om een " +
                "telefoonnummer vragen."
        },
        {
            id: 2,
            title: "Serviceverlening",
            content:
                "Het kan zijn dat u onze klantenservice benadert met een " +
                "vraag. De e-mails die u ons stuurt bewaren wij maximaal " +
                "zes maanden."
        },
        {
            id: 3,
            title: "Nieuwsbrief en marketing",
            content:
                "Wij informeren u graag over nieuwe producten en stellen " +
                "het op prijs als u zich aanmeldt voor de nieuwsbrief. " +
                "Uw e-mailadres wordt toegevoegd aan ons bestand. " +
                "Voor onze mailings kunnen wij gebruik maken van de " +
                "diensten van een marketingpartner die ons hiervoor software" +
                " levert. Op basis van de Telecommunicatiewet en AVG (47) " +
                "sturen wij zakelijke klanten enkele malen per jaar e-mails " +
                "met aanbiedingen en informatie over nieuwe producten. " +
                "Dit doen wij op grond van de direct marketing clausule zoals " +
                "omschreven in de Algemene Verordening Gegevensbescherming. " +
                "Hierbij maken wij altijd de door de AVG " +
                "vereiste belangenafweging."
        },
        {
            id: 4,
            title: "Bewaartermijn",
            content:
                "De persoonsgegevens die wij verwerken in het kader " +
                "van de levering blijven standaard voor maximaal één jaar " +
                "op onze digitale systemen staan. Na een periode van twee " +
                "weken na de bestelling wordt de bestelinformatie exclusief " +
                "bewaard in een database met een zwaarder beveiligingsregime. " +
                "Emailcorrespondentie met onze klantenservice bewaren wij " +
                "zes maanden."
        },
        {
            id: 5,
            title: "Veiligheid",
            content:
                "Uw informatie beveiligen wij zowel digitaal als fysiek. " +
                "Uw bestelling en contact met ons verloopt via een beveiligde " +
                "verbinding. In de adresbalk van uw webbrowser kunt u het " +
                "certificaat controleren. In samenwerking met onze " +
                "hostingprovider en webbeheerder is het monitoren van " +
                "de veiligheid van onze websites en uw gegevens een " +
                "dagelijks onderdeel van de werkzaamheden. In geval van " +
                "een datalek zullen wij alle daarvoor geëigende procedures " +
                "volgen. Deze hebben wij vastgelegd in een intern " +
                "veiligheidsprotocol."
        },
        {
            id: 6,
            title: "Fraude",
            content:
                "Wij gebruiken klantgegevens om fraude te onderzoeken. " +
                "Helaas komt het voor dat men probeert dinerbonnen te " +
                "verwerven zonder hiervoor te betalen. Om herhaling te " +
                "voorkomen slaan wij gegevens van fraudeurs op. Indien " +
                "nodig delen wij deze informatie met de overheid en " +
                "partnerwebsites."
        },
        {
            id: 7,
            title: "Verdubbelaar",
            content:
                "Eenieder die zich aanmeldt voor de nieuwsbrief doet mee " +
                "aan de maandelijkse verdubbelaarsactie. " +
                "Om contact met u op te nemen en een winnaar te " +
                "kiezen hebben wij jouw naam en e-mailadres, " +
                "adresgegevens nodig (voor het verzenden van de dinerbon)."
        },
        {
            id: 8,
            title: "Cookies",
            content:
                "Op onze website gebruiken wij functionele en " +
                "analytische cookies. Cookies zijn kleine bestanden die " +
                "op uw harde schijf worden opgeslagen en informatie bevatten " +
                "over uw surfgedrag op onze pagina. Zonder deze cookies zou " +
                "de website niet optimaal functioneren. Zo kunnen wij zien " +
                "welke browser u gebruikt en de website optimaal weergeven. " +
                "Ook voor het bijhouden van de producten in het winkelmandje " +
                "plaatsen wij een functionele cookie. Verder gebruiken wij " +
                "analytische cookies die het verkeer op onze website " +
                "registreren. Hierdoor zien wij ook of u een terugkerende " +
                "bezoeker bent. Op deze manier kunnen wij de website en " +
                "onze service verbeteren. Voor een overzicht van de cookies, " +
                "de bijbehorende verzameldoeleinden en de bewaartermijnen " +
                "verwijzen wij u graag door naar de speciaal hiervoor " +
                "ingerichte cookieverklaring."
        },
        {
            id: 9,
            title: "Recht op vergetelheid",
            content:
                "U kunt altijd verzoeken om verwijdering of aanpassing " +
                "van uw gegevens. Hier zullen wij in alle gevallen gehoor " +
                "aan geven, tenzij een wettelijke regeling zich hier " +
                "tegen verzet. Mocht u specifieke vragen hebben over onze " +
                "privacyregeling neem dan contact op met onze klantenservice " +
                "en vraag naar de privacyfunctionaris."
        },
        {
            id: 10,
            title: "Autoriteit persoonsgegevens",
            content:
                "Natuurlijk helpen wij u graag verder als u klachten " +
                "heeft over de verwerking van uw persoonsgegevens. " +
                "Op grond van de privacywetgeving heeft u ook het " +
                "recht om een klacht in te dienen bij de Autoriteit pagina " +
                "3 van 4 Persoonsgegevens tegen deze verwerkingen van " +
                "persoonsgegevens. U kunt hiervoor contact opnemen met " +
                "de Autoriteit Persoonsgegevens."
        }
    ]
};
